import { Grid } from '@material-ui/core'
import { Button, useNotify, useRefresh } from 'react-admin'
import Api from '../../../Apis/api.service'
import { useStyles } from '../styles'

export const CloseButton = ({
  setOpenResolutionId,
  setIsChanged,
  resolution,
  ag,
  onSuccess,
}) => {
  const refresh = () => {
    setIsChanged((prev) => {
      let newVal = new Date().getTime()
      return newVal
    })
  }
  const notify = useNotify()
  const classes = useStyles()

  if (!resolution || !resolution.opened) return null

  const close = () =>
    Api.ags3
      .update(ag.id, { close_open_resolution_id: true })
      .then((response) => {
        notify('Résolution fermée')
        onSuccess()
        if (setOpenResolutionId) {
          setOpenResolutionId(null)
          refresh()
        } else refresh()
      })
      .catch((error) => {
        //error.case is not accessible but error.message is, dunno why
        notify(`${error.message}`, 'warning')
      })

  return (
    <Grid item xs={12}>
      <Button
        className={classes.actionButton}
        variant="contained"
        size="normal"
        color="secondary"
        label="Clôturer les votes"
        onClick={close}
      />
    </Grid>
  )
}
export default CloseButton
